import Button from '@standardsdigital/ui-components/Button';
import Dialog from '@standardsdigital/ui-components/Dialog';
import { useTranslation } from 'react-i18next';
import styles from '../ServiceLevelForm.module.css';

interface ConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

function ConfirmationDialog({
  open,
  onOpenChange,
  onConfirm,
}: Readonly<ConfirmationDialogProps>) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      closeButtonText={t('general.close')}
      title={t('serviceLevels.form.updateExistingSubscriptionsConfirmationTitle')}
      description={t(
        'serviceLevels.form.updateExistingSubscriptionsConfirmationDescription',
      )}
      onOpenChange={onOpenChange}
    >
      <div className={styles.dialogActions}>
        <Button type="button" variant="primary" onClick={onConfirm}>
          {t('general.save')}
        </Button>
        <Button
          type="button"
          variant="secondary"
          onClick={() => onOpenChange(false)}
        >
          {t('general.cancel')}
        </Button>
      </div>
    </Dialog>
  );
}

export default ConfirmationDialog;
